let isHandoffActive = false

export function startOrgSwitchHandoff() {
  isHandoffActive = true
}

export function endOrgSwitchHandoff() {
  isHandoffActive = false
}

export function isOrgSwitchHandoffActive() {
  return isHandoffActive
}
